// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2P0WH","dragIcon":"Choice_dragIcon__1Q5ab","left":"Choice_left___UW42","input":"Choice_input__2pkw9"};